<script setup lang="ts" generic="T, MM">
import FormField from '@/components/input/FormField.vue'
import { Validation } from '@vuelidate/core'

const props = defineProps<{
  label?: string
  validation?: Validation
}>()

const model = defineModel<T | undefined>()

defineOptions({ inheritAttrs: false })
</script>

<template>
  <form-field :label="props.label" :validation="props.validation">
    <v-autocomplete v-bind="$attrs" v-model="model" hide-details @blur="props.validation?.$touch">
      <template v-for="(_, slot) of $slots" #[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-autocomplete>
  </form-field>
</template>
